import React from 'react';
import IndexPage from '@/portal/routes/providers/index/Page.tsx';
import { LoaderFunctionArgs } from 'react-router-dom';
import { loadProviders } from '@/common/api/Providers.ts';
import { loadInsuranceCompanies } from '@/common/api/InsuranceCompanies.ts';

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const params = new URLSearchParams(url.search);
  const [providers, insuranceCompanies] = await Promise.all([
    loadProviders(params),
    loadInsuranceCompanies(),
  ]);
  return { providers, insuranceCompanies };
}

const IndexRoute: React.FC = () => {
  return <IndexPage />;
};

export default IndexRoute;
